import { DashboardHeader } from '@modules/admin/Admin.Header'
import { Loading } from '@modules/core/components/Loading'
import React, { Component } from 'react'
import { Trans, withTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import Consultations from '@services/Consultations'
import DerivationsForm from './Derivation.Form'

class DerivationUpdate extends Component {
  state = {
    id: this.props.match.params.derivationId,
    deleteModal: false,
    derivation: undefined,
    isFetching: false,
  }

  componentDidMount() {
    this.setState({ isFetching: true })
    Consultations.externalDerivations
      .show(this.state.id)
      .then((response) => {
        const parsedResponse = {
          ...response.data,
          phone: { phone: response.data.phone_value },
        }
        this.setState({ derivation: parsedResponse, isFetching: false })
      })
      .catch((err) => {
        this.setState({ derivation: undefined, isFetching: false })
        window.alert(JSON.stringify(err.message, null, 2))
      })
  }

  render() {
    const { derivation, isFetching } = this.state
    return (
      <div className="crud-wrapper ">
        <DashboardHeader title={<Trans>Editar Derivación</Trans>}>
          <Link to={`/derivations`} className="btn btn-primary">
            <Trans>Volver</Trans>
          </Link>
        </DashboardHeader>
        <Loading isFetching={isFetching} />
        <div className="main-content">{derivation && <DerivationsForm initialValues={derivation} />}</div>
      </div>
    )
  }
}

export default withTranslation()(DerivationUpdate)
